import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import classes from "./ADLogin.module.css";

interface LogoutModalProps {
  onClose: () => void;
}

const LogoutModal = ({ onClose }: LogoutModalProps) => {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div
        className={classes.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.modalHeader}>{t("login.logoutModalTitle")}</div>
        <div className={classes.modalBody}>{t("login.logoutModalText")}</div>
        <div className={classes.modalFooter}>
          <button className={classes.cancelButton} onClick={onClose}>
            {t("login.cancelLogout")}
          </button>
          <button className={classes.confirmButton} onClick={handleLogout}>
            {t("login.confirmLogout")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;